import { useState, type ReactNode } from 'react';
import { managerApi } from '../lib/api';
import { errorMessage } from './ErrorModalBody';

const SESSION_KEY = 'coala.specialSenha';

/** Portão mais restrito que o OwnerGate: só aceita a senha especial
 * (a mesma de trocar tipo de horário), NUNCA uma senha mestre — usado pra
 * auditoria, onde só quem tem essa senha específica deve poder ver o
 * registro das ações de quem usa senha mestre. */
export function SpecialGate({ children }: { children: (senha: string) => ReactNode }) {
  const [senhaOk, setSenhaOk] = useState<string | null>(() => sessionStorage.getItem(SESSION_KEY));
  const [senha, setSenha] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function unlock() {
    setError('');
    setBusy(true);
    try {
      const trimmed = senha.trim();
      await managerApi.verifySpecialAccess(trimmed);
      sessionStorage.setItem(SESSION_KEY, trimmed);
      setSenhaOk(trimmed);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  if (senhaOk !== null) return <>{children(senhaOk)}</>;

  return (
    <div className="card">
      <h2>Acesso restrito</h2>
      <p className="hint">Esta área exige a senha especial — senhas mestres normais não dão acesso aqui.</p>
      <label>Senha</label>
      <input type="password" value={senha} onChange={(e) => setSenha(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') unlock(); }} />
      {error && <div className="err">{error}</div>}
      <button className="btn btn-primary btn-block" style={{ marginTop: 14 }} disabled={busy} onClick={unlock}>Desbloquear</button>
    </div>
  );
}
